export class InsertUser {
    name: string;
    email: string;
    roles:Roles[];
}

export class Roles{
    id:number;
    roleName:string;
}